import { motion } from 'framer-motion';

export default function MapSection() {
  return (
    <section className="py-24 px-6 bg-[#F8F7F4]">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-[#101A2E] mb-6 text-center" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Место и как добраться
          </h2>
          
          <p className="text-lg text-[#1E2430] text-center mb-12">
            Отель «Москва», зал «Белые ночи»
          </p>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-[#101A2E] mb-6 flex items-center gap-3">
                <i className="ri-map-pin-line text-[#D8B36A] text-3xl"></i>
                Адрес
              </h3>
              <p className="text-base text-[#1E2430] mb-4 leading-relaxed">
                <strong>Санкт-Петербург</strong><br />
                пл. Александра Невского, дом 2<br />
                отель «Москва»
              </p>
              <div className="space-y-3 text-sm text-[#1E2430]/80">
                <div className="flex items-start gap-3">
                  <i className="ri-subway-line text-[#D8B36A] text-lg mt-0.5"></i>
                  <span>м. «Площадь Александра Невского» — 3–5 минут пешком</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-direction-line text-[#D8B36A] text-lg mt-0.5"></i>
                  <span>Указатели в лобби отеля</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-shirt-line text-[#D8B36A] text-lg mt-0.5"></i>
                  <span>Гардероб на месте</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-restaurant-line text-[#D8B36A] text-lg mt-0.5"></i>
                  <span>Кафе рядом</span>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl overflow-hidden shadow-lg">
              <iframe
                src="https://yandex.ru/map-widget/v1/?ll=30.386420,59.924037&z=16&l=map&pt=30.386420,59.924037,pm2rdm"
                width="100%"
                height="100%"
                frameBorder="0"
                className="min-h-[400px]"
                title="Карта: Отель Москва, Санкт-Петербург"
              ></iframe>
            </div>
          </div>

          <div className="bg-gradient-to-r from-[#D8B36A]/10 to-[#C9A459]/10 rounded-2xl p-6 border border-[#D8B36A]/20">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-[#D8B36A] rounded-xl flex-shrink-0">
                <i className="ri-information-line text-white text-xl"></i>
              </div>
              <div>
                <h4 className="text-lg font-bold text-[#101A2E] mb-2">Полезная информация</h4>
                <p className="text-sm text-[#1E2430]/80 leading-relaxed">
                  Рекомендуем приехать за 15–20 минут до начала для регистрации и кофе-брейка. Парковка доступна на территории отеля.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}